import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const getIniView = ({
	currentStartAt,
	currentEndAt,
	currentContent,
	placeholderContent,
	contentTimeList,
}) => {
	const now = dayjs().utc();
	const start = dayjs(currentStartAt).utc();
	const startTimeDifference = start.diff(now);
	const end = dayjs(currentEndAt).utc();
	const endTimeDifference = end.diff(now);
	let iniView;
	let fetchContent = false;
	if (currentContent && startTimeDifference <= 0 && endTimeDifference > 0) {
		iniView = currentContent;
	} else {
		if (contentTimeList)
			contentTimeList.forEach(c => {
				const _startTimeDifference = dayjs(c.startAt).utc().diff(now);
				const _endTimeDifference = dayjs(c.endAt).utc().diff(now);
				if (_startTimeDifference <= 0 && _endTimeDifference > 0) {
					fetchContent = true;
				}
			});
		if (!fetchContent) {
			iniView = placeholderContent;
		}
	}
	return iniView;
};

const useTimer = (settings, fetchContentAsync) => {
	const [data, setData] = useState([]);

	useEffect(() => {
		const renderContent = getIniView(settings);
		if (!renderContent) {
			fetchContentAsync()
				.then(latestContent => setData(latestContent))
				.catch(err => {
					console.error("Unable to load latest timed content", err);
					setData(renderContent);
				});
		} else {
			setData(renderContent);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settings]);

	return data;
};

const TimedContent = ({ settings, fetchContentAsync, renderContent }) => {
	const content = useTimer(settings, fetchContentAsync);

	return renderContent(content);
};

TimedContent.propTypes = {
	settings: PropTypes.shape({
		currentStartAt: PropTypes.string,
		currentEndAt: PropTypes.string,
		currentContent: PropTypes.arrayOf(PropTypes.object),
		placeholderContent: PropTypes.arrayOf(PropTypes.object),
		contentTimeList: PropTypes.arrayOf(
			PropTypes.shape({
				startAt: PropTypes.string,
				endAt: PropTypes.string,
			})
		),
	}),
	fetchContentAsync: PropTypes.func.isRequired,
	renderContent: PropTypes.func,
};

TimedContent.defaultProps = {
	renderContent: content => content,
};

export { TimedContent };
